import { gql } from 'graphql-request';

export const QUERY_LISTING_ENTITIES = gql`
  query ListingEntities($listingId: String!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    lookupListingEntities(id: { listingId: $listingId }) {
      listingEntities {
        entityId
        hcAddressId
        hcMlsId
      }
    }
  }
`;
